import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { type Shipper } from 'spot-quote/domain/Shipper'
import styled from 'styled-components/macro'

import { Breadcrumbs, Layout } from '@loadsmart/loadsmart-ui'

import { user } from 'legacy/utils/user'

import { ShipperContactInformation } from './ShipperContactInformation'

const StyledBreadcrumbs = styled(Breadcrumbs)`
  align-items: center;
`

export type SpotQuotePageHeaderProps = {
  shipper: Shipper
}

export function SpotQuotePageHeader({ shipper }: SpotQuotePageHeaderProps) {
  const history = useHistory()
  const shouldDisplayBreadcrumbs = user.isLoggedIn()

  const handleBackToLoadboard = useCallback(() => {
    history.push('/loads')
  }, [history])

  const breadcrumbEntries = useMemo(
    () => [
      {
        label: 'Loads',
        onClick: handleBackToLoadboard,
      },
      { label: `${shipper.name}'s Bid Invitation` },
    ],
    [shipper.name, handleBackToLoadboard]
  )

  return (
    <Layout.Group justify={'space-between'} align="center">
      <div>
        {shouldDisplayBreadcrumbs && (
          <StyledBreadcrumbs onBack={handleBackToLoadboard} entries={breadcrumbEntries} />
        )}
      </div>
      <ShipperContactInformation shipper={shipper} />
    </Layout.Group>
  )
}
